import React from 'react';
import Button from '@material-ui/core/Button';
import classnames from 'classnames';
import TriggerRuleStore from 'stores/triggers/TriggerRuleStore';
import './RuleTypeSelect.styl';
import UnsavedTriggerActions from 'actions/triggers/UnsavedTriggerActions';
import {UserHeadsetIcon} from '@components/icon/UserHeadsetIcon';
import {OverlappingCommentsIcon} from '@components/icon/OverlappingCommentsIcon';
import {BoltIcon} from '@components/icon/BoltIcon';
import {ChartLineUpIcon} from '@components/icon/ChartLineUpIcon';

export default class RuleTypeSelect extends React.Component {
  constructor(props) {
    super(props);

    this.nextClick = this.nextClick.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);

    this.state = {
      triggerType: undefined,
      actionType: undefined,
    };
  }

  nextClick() {
    const {triggerType, actionType} = this.state;
    UnsavedTriggerActions.setActionType(actionType);
    this.props.selectType({triggerType, actionType});
  }

  updateDimensions() {
    this.setState({
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    });
  }

  render() {
    const {triggerType, actionType} = this.state;
    const canNext = !!triggerType && !!actionType;
    const canCancel = TriggerRuleStore.getState().rules.size > 0;
    return (
      <div className="rule-type-select">
        <p>
          We can sends alerts based on rules you set. Create rules for feedback or call patterns and
          configure your alert by selecting buttons below.
        </p>
        <p className="rule-title">What will trigger the alert?</p>
        <div className="selections">
          <div
            className={classnames(
              'call-type',
              'type-select-box',
              triggerType === 'call_trigger' && 'active',
              triggerType && triggerType !== 'call_trigger' && 'un-selected'
            )}
            onClick={() => this.setState({triggerType: 'call_trigger'})}>
            <div className="image-placeholder">
              <UserHeadsetIcon />
            </div>
            <div className="description">Call Activity</div>
          </div>
          <div
            className={classnames(
              'call-type',
              'type-select-box',
              triggerType === 'feedback_trigger' && 'active',
              triggerType && triggerType !== 'feedback_trigger' && 'un-selected'
            )}
            onClick={() => this.setState({triggerType: 'feedback_trigger'})}>
            <div className="image-placeholder">
              <OverlappingCommentsIcon />
            </div>
            <div className="description">Coaching Activity</div>
          </div>
        </div>
        <p className="rule-title">What type of alert is this?</p>
        <div className="selections">
          <div
            className={classnames(
              'call-type',
              'type-select-box',
              actionType === 'event' && 'active',
              actionType && actionType !== 'event' && 'un-selected'
            )}
            onClick={() => this.setState({actionType: 'event'})}>
            <div className="image-placeholder">
              <BoltIcon />
            </div>
            <div className="description">An Event</div>
          </div>
          <div
            className={classnames(
              'call-type',
              'type-select-box',
              actionType === 'trend' && 'active',
              actionType && actionType !== 'trend' && 'un-selected'
            )}
            onClick={() => this.setState({actionType: 'trend'})}>
            <div className="image-placeholder">
              <ChartLineUpIcon />
            </div>
            <div className="description">A Trend</div>
          </div>
        </div>
        <div className="button-container">
          <Button
            variant="contained"
            color="primary"
            className="ev-button"
            disabled={!canNext}
            onClick={this.nextClick}>
            Next
          </Button>
          {canCancel && (
            <Button variant="outlined" className="ev-button" onClick={this.props.cancelClick}>
              Cancel
            </Button>
          )}
        </div>
      </div>
    );
  }
}
